import { css } from '@emotion/react';
import * as theme from '../theme';
export const fontSans = /*#__PURE__*/css({
  fontFamily: theme.fontFamily.sans
}, process.env.NODE_ENV === "production" ? "" : ";label:fontSans;");
export const fontSerif = /*#__PURE__*/css({
  fontFamily: theme.fontFamily.serif
}, process.env.NODE_ENV === "production" ? "" : ";label:fontSerif;");
export const fontMono = /*#__PURE__*/css({
  fontFamily: theme.fontFamily.mono
}, process.env.NODE_ENV === "production" ? "" : ";label:fontMono;");
export const fontInputHelper = /*#__PURE__*/css({
  fontFamily: theme.fontFamily.inputHelper
}, process.env.NODE_ENV === "production" ? "" : ";label:fontInputHelper;");